import { URI } from '@/config/config';

export default async ({ rootState }, { roleId }) => {
  const opts = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const requestList = await fetch(`${URI}control-panel/roles/${roleId}`, opts);
  const jsonResult = await requestList.json();

  if (jsonResult.message) {
    return Promise.reject(jsonResult.message);
  }

  return;
};
